var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgSearch = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "none",
  viewBox: "0 0 24 24"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "currentColor",
  fillRule: "evenodd",
  d: "M10 3.85a6.15 6.15 0 1 0 0 12.3 6.15 6.15 0 0 0 0-12.3M2.15 10a7.85 7.85 0 1 1 13.97 4.917L21.6 20.4a.85.85 0 1 1-1.202 1.202l-5.482-5.482A7.85 7.85 0 0 1 2.15 10",
  clipRule: "evenodd"
})));
export default SvgSearch;